/**
 * UPSELL DRAWER CAROUSEL
 * Gère la navigation du carousel d'upsell avec réinitialisation automatique
 */

function initUpsellCarousel() {
  // RÉCUPÉRATION DES ÉLÉMENTS DOM
  const container = document.querySelector('.upsell-drawer-scroll');
  const pagination = document.querySelector('.upsell-drawer-pagination');
  const dots = pagination?.querySelectorAll('.upsell-drawer-pagination_dot');
  const cards = container?.querySelectorAll('.upsell-drawer-card');
  
  if (!container || !pagination || !dots || !cards || cards.length === 0) {
    return;
  }

  // VARIABLES D'ÉTAT
  let currentIndex = 0;
  const totalCards = cards.length;
  let isNavigating = false;
  let leftWheelClone = null;
  let rightWheelClone = null;

  // FONCTION DE VERROUILLAGE
  function lockNavigation(duration = 350) {
    isNavigating = true;
    setTimeout(() => {
      isNavigating = false;
    }, duration);
  }

  // MISE À JOUR DES DOTS
  function updateDots(index) {
    dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
    });
  }

  // GESTION CLONES WHEEL (GAUCHE + DROITE)
  function updateWheelClones(currentIndex) {
  
  // Calculer les index des cartes précédente et suivante (effet wheel infini)
  const prevIndex = currentIndex === 0 ? totalCards - 1 : currentIndex - 1;
  const nextIndex = currentIndex === totalCards - 1 ? 0 : currentIndex + 1;
  
  const prevCard = cards[prevIndex];
  const nextCard = cards[nextIndex];
  
  // Distance entre cartes
  const card1 = container.querySelector('.upsell-drawer-card:nth-child(1)');
  const card2 = container.querySelector('.upsell-drawer-card:nth-child(2)');
  let exactDistance = 381; // fallback
  
  if (card1 && card2) {
    exactDistance = card2.offsetLeft - card1.offsetLeft;
  }
  
  // === CLONE GAUCHE (carte précédente) ===
  if (leftWheelClone) {
    leftWheelClone.remove();
    leftWheelClone = null;
  }
  
  if (prevCard) {
    leftWheelClone = prevCard.cloneNode(true);
    leftWheelClone.style.position = 'absolute';
    leftWheelClone.style.zIndex = '1';
    leftWheelClone.style.opacity = '0.7';
    leftWheelClone.style.pointerEvents = 'none';
    leftWheelClone.classList.add('wheel-clone-left');
    
    container.appendChild(leftWheelClone);
    
    leftWheelClone.style.left = `-${exactDistance}px`;
    leftWheelClone.style.top = '0px';
    leftWheelClone.style.width = card1?.offsetWidth + 'px';
    leftWheelClone.style.height = card1?.offsetHeight + 'px';
  }
  
  // === CLONE DROITE (carte suivante) ===
  if (rightWheelClone) {
    rightWheelClone.remove();
    rightWheelClone = null;
  }
  
  if (nextCard) {
    rightWheelClone = nextCard.cloneNode(true);
    rightWheelClone.style.position = 'absolute';
    rightWheelClone.style.zIndex = '1';
    rightWheelClone.style.opacity = '0.7';
    rightWheelClone.style.pointerEvents = 'none';
    rightWheelClone.classList.add('wheel-clone-right');
    
    container.appendChild(rightWheelClone);
    
    // Positionner à droite de la dernière carte visible
    const visibleCards = container.querySelectorAll('.upsell-drawer-card:not(.wheel-clone-left):not(.wheel-clone-right)');
    const lastVisibleCard = visibleCards[visibleCards.length - 1];
    
    if (lastVisibleCard) {
      rightWheelClone.style.left = `${lastVisibleCard.offsetLeft + exactDistance}px`;
      rightWheelClone.style.top = '0px';
      rightWheelClone.style.width = card1?.offsetWidth + 'px';
      rightWheelClone.style.height = card1?.offsetHeight + 'px';
    }
  }
}

  // FONCTION DE NAVIGATION PRINCIPALE
  function goToCard(targetIndex) {
    // VÉRIFICATION VERROUILLAGE
    if (isNavigating) {
      return false;
    }
    
    // VERROUILLAGE IMMÉDIAT
    lockNavigation();
    
    // NAVIGATION CIRCULAIRE
    if (targetIndex < 0) {
      targetIndex = totalCards - 1;
    } else if (targetIndex >= totalCards) {
      targetIndex = 0;
    }
    
    // CALCUL POSITION
    const card1 = container.querySelector('.upsell-drawer-card:nth-child(1)');
    const card2 = container.querySelector('.upsell-drawer-card:nth-child(2)');
    
    if (card1 && card2) {
      const exactDistance = card2.offsetLeft - card1.offsetLeft;
      const REFERENCE_POSITION = 41;
      const translateX = REFERENCE_POSITION - (targetIndex * exactDistance);
      
      // APPLICATION TRANSFORM
      container.style.transform = `translate3d(${translateX}px, 0px, 0px)`;
    }
    
    // MISE À JOUR ÉTAT
    currentIndex = targetIndex;
    updateDots(targetIndex);
    updateWheelClones(targetIndex);
    
    return true; // Navigation réussie
  }

  // GESTIONNAIRE WHEEL
  function handleWheelEvent(e) {
    e.preventDefault();
    
    if (isNavigating) {
      return;
    }
    
    const deltaX = e.deltaX || e.deltaY;
    if (Math.abs(deltaX) < 5) {
      return;
    }
    
    const direction = deltaX > 0 ? 1 : -1;
    const targetIndex = currentIndex + direction;
    
    goToCard(targetIndex);
  }

  // GESTIONNAIRE TOUCH/SWIPE POUR MOBILE
  let touchStartX = 0;
  let touchEndX = 0;
  let touchStartY = 0;
  let touchEndY = 0;

  function handleTouchStart(e) {
    touchStartX = e.changedTouches[0].screenX;
    touchStartY = e.changedTouches[0].screenY;
  }

  function handleTouchMove(e) {
    touchEndX = e.changedTouches[0].screenX;
    touchEndY = e.changedTouches[0].screenY;
  }

  function handleTouchEnd(e) {
    if (isNavigating) {
      return;
    }

    const deltaX = touchStartX - touchEndX;
    const deltaY = touchStartY - touchEndY;
    
    // Vérifier que c'est un swipe horizontal (pas vertical)
    if (Math.abs(deltaX) < Math.abs(deltaY)) {
      return;
    }
    
    // Minimum 50px pour déclencher le swipe
    if (Math.abs(deltaX) < 50) {
      return;
    }
    
    const direction = deltaX > 0 ? 1 : -1; // Swipe gauche = next, Swipe droite = prev
    const targetIndex = currentIndex + direction;
    
    goToCard(targetIndex);
    
    // Reset
    touchStartX = 0;
    touchEndX = 0;
    touchStartY = 0;
    touchEndY = 0;
  }

  // INSTALLATION ÉVÉNEMENTS
  container.addEventListener('wheel', handleWheelEvent, { passive: false });
  
  // Événements tactiles pour mobile
  container.addEventListener('touchstart', handleTouchStart, { passive: true });
  container.addEventListener('touchmove', handleTouchMove, { passive: true });
  container.addEventListener('touchend', handleTouchEnd, { passive: true });
  
  // Dots
  dots.forEach((dot, index) => {
    dot.addEventListener('click', (e) => {
      e.preventDefault();
      goToCard(index);
    });
  });

  // Prev / Next buttons
  const prevBtn = document.querySelector('.upsell-pagination-button.prev');
  const nextBtn = document.querySelector('.upsell-pagination-button.next');
  
  if (prevBtn) {
    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      goToCard(currentIndex - 1);
    });
  }
  
  if (nextBtn) {
    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      goToCard(currentIndex + 1);
    });
  }

  // GESTION des dropdowns de variantes
  const variantSelects = document.querySelectorAll('.upsell-drawer-variant-select');
  variantSelects.forEach(select => {
    select.addEventListener('change', function() {
      const productId = this.dataset.productId;
      const selectedVariantId = this.value;
      
      // Mettre à jour l'input caché du formulaire correspondant
      const variantInput = document.querySelector(`input[data-variant-input="${productId}"]`);
      if (variantInput) {
        variantInput.value = selectedVariantId;
      }
    });
  });

  // INITIALISATION POSITION ET WHEEL
  
  // Configuration container pour le clone wheel
  container.style.position = 'relative';
  
  // Permettre l'affichage du clone à gauche
  const containerParent = container.parentElement;
  if (containerParent) {
    containerParent.style.overflow = 'visible';
  }
  
  // Position initiale et clones wheel
  updateDots(0);
  updateWheelClones(0);
  container.style.transform = 'translate3d(41px, 0px, 0px)';
}

// GESTION GLOBALE DES FORMULAIRES UPSELL (EN DEHORS DE initUpsellCarousel)
// Utiliser un flag pour éviter d'attacher le listener plusieurs fois
if (!window.upsellFormHandlerAttached) {
  window.upsellFormHandlerAttached = true;
  
  // Map pour tracker les soumissions en cours par formulaire
  const submittingForms = new Map();
  
  // Gestion des formulaires (délégation pour survivre aux re-render du drawer)
  document.addEventListener('submit', function(e) {
    const form = e.target.closest('.upsell-drawer-form');
    if (!form) return;
    e.preventDefault();
    
    // Vérifier si ce formulaire est déjà en cours de soumission
    const formId = form.querySelector('input[name="id"]')?.value || Math.random();
    if (submittingForms.has(formId)) {
      console.log('⚠️ Soumission ignorée - formulaire déjà en cours', formId);
      return;
    }
    
    // Marquer comme en cours
    submittingForms.set(formId, true);

    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const button = form.querySelector('.upsell-drawer-card_add');
    const originalText = button ? button.textContent : '';

    if (button) {
      button.textContent = '+';
      button.disabled = true;
    }

    try {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(form);
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') {
          cart.setActiveElement(document.activeElement);
        }
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          // Retirer le flag de soumission
          submittingForms.delete(formId);
          
          if (response.status) {
            if (button) {
              button.textContent = originalText;
              button.disabled = false;
            }
            return;
          }

          // Mettre à jour le cart drawer avec les sections renvoyées
          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(response);
          } else {
            // Fallback: publier un event cartUpdate pour rafraîchir les sections par fetch
            try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'upsell-drawer', cartData: response }); } catch (e) {}
          }
        })
        .catch((error) => {
          // Retirer le flag de soumission en cas d'erreur
          submittingForms.delete(formId);
          
          if (button) {
            button.textContent = originalText;
            button.disabled = false;
          }
        });
    } catch (err) {
      // Retirer le flag de soumission en cas d'erreur
      submittingForms.delete(formId);
      
      if (button) {
        button.textContent = originalText;
        button.disabled = false;
      }
    }
  }, true); // Utiliser capture phase pour être sûr d'intercepter en premier
}

// INITIALISATION AU CHARGEMENT DE LA PAGE
document.addEventListener('DOMContentLoaded', initUpsellCarousel);

// RÉINITIALISATION APRÈS MISE À JOUR DU PANIER
if (typeof MutationObserver !== 'undefined') {
  const observerCallback = function(mutations) {
    for (let mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        for (let node of mutation.addedNodes) {
          if (node.nodeType === 1) {
            const hasUpsellClass = node.classList?.contains('upsell-drawer');
            const hasUpsellChild = node.querySelector?.('.upsell-drawer');
            
            if (hasUpsellClass || hasUpsellChild) {
              setTimeout(() => {
                initUpsellCarousel();
              }, 100);
              break;
            }
          }
        }
      }
    }
  };
  
  const observer = new MutationObserver(observerCallback);
  
  const startObserving = function() {
    const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('.cart-drawer');
    if (cartDrawer) {
      observer.observe(cartDrawer, { childList: true, subtree: true });
    } else {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  };
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }
}
